import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "lib/scroll";

export default function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.slice(1);
    const timeoutId = window.setTimeout(() => scrollToId(id), 50);
    return () => window.clearTimeout(timeoutId);
  }, [location]);

  return null;
}
